export default __webpack_public_path__ + "static/media/Fest pics.625bf90c.png";